// Presentation only: never writes normalized content back to settings/home.
const list = value => Array.isArray(value) ? value : [];
const text = value => typeof value === 'string' ? value.trim() : '';
export const phoneHref = value => `tel:${text(value).replace(/[^+\d]/g, '')}`;

const serviceVisuals = {
  '3d mum basımı': { image: '/assets/wax 1.png', art: 'wax-photo' },
  'mum basımı': { image: '/assets/wax 1.png', art: 'wax-photo' },
  'kalıp kesimi': { image: '/assets/molding 1.png', art: 'molding-photo' },
  'kaliteli döküm': { image: '/assets/casting 2.png', art: 'casting-photo' },
  'değerli maden dökümü': { image: '/assets/casting 2.png', art: 'casting-photo' },
  'hızlı teslimat': { visualIcon: 'hourglass' },
  'müşteri memnuniyeti': { visualIcon: 'online-support' },
};
const serviceGroups = [
  { title: 'Değerli Maden Dökümü', aliases: ['değerli maden dökümü', 'kaliteli döküm'] },
  { title: '3D Mum Basımı', aliases: ['3d mum basımı', 'mum basımı'] },
  { title: 'Kalıp Kesimi', aliases: ['kalıp kesimi'] },
];

export function landingContent(settings) {
  const serviceItems = list(settings.services?.items);
  const contact = settings.contact || {};
  const legacyAddresses = list(contact.addresses);
  const maps = list(contact.mapUrls);
  // Legacy arrays are authoritative; homeApi also supplies newer default fields.
  const branches = Array.isArray(contact.addresses)
    ? legacyAddresses.map((address, index) => {
        const map = maps.find(item => item.title === address.title) || maps[index];
        return {
          name: `${String(index + 1).padStart(2, '0')} / ${text(address.title).toLocaleUpperCase('tr-TR')}`,
          heading: text(address.title),
          address: text(address.value),
          mapUrl: text(map?.value),
          directionsUrl: text(address.value)
            ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address.value)}`
            : '',
        };
      })
    : list(contact.branches).map(branch => ({ ...branch, directionsUrl: branch.mapUrl }));
  const phones = Array.isArray(contact.phones)
    ? contact.phones.map(item => ({ title: text(item.title), value: text(item.value) }))
    : contact.phone
      ? [{ title: 'Telefon', value: text(contact.phone) }]
      : branches.filter(branch => branch.phone).map(branch => ({ title: text(branch.name).replace(/^\d+\s*\/\s*/, '') || branch.heading, value: branch.phone }));
  const emails = Array.isArray(contact.emails)
    ? contact.emails.map(item => ({ title: text(item.title), value: text(item.value) }))
    : contact.email ? [{ title: 'E-posta', value: text(contact.email) }] : [];
  const hours = settings.footer?.workingHours ?? contact.workingHours;
  return {
    hero: {
      ...settings.hero,
      image: settings.hero?.image || '/assets/casting.jpg',
    },
    about: {
      ...settings.about,
      // The uploaded copy replaces the old external host for this same photo.
      image: !settings.about?.image || settings.about.image.startsWith('https://i.hizliresim.com/cnlkg8x.jpg')
        ? '/assets/atelier.jpg' : settings.about.image,
    },
    services: {
      ...settings.services,
      items: serviceGroups.map(group => {
        const item = group.aliases.map(alias => serviceItems.find(service => text(service.title).toLocaleLowerCase('tr-TR') === alias)).find(Boolean);
        if (!item) return null;
        const visual = serviceVisuals[text(item.title).toLocaleLowerCase('tr-TR')] || { visualIcon: 'services' };
        return {
          ...item,
          ...visual,
          title: group.title,
          ...(text(item.image) ? { image: item.image, visualIcon: undefined } : {}),
          // Do not display punctuation-only placeholder content as a description.
          description: /[\p{L}\p{N}]/u.test(text(item.description)) ? item.description : '',
        };
      }).filter(Boolean),
    },
    contact: {
      ...contact, branches,
      phones: phones.filter(item => item.value),
      emails: emails.filter(item => item.value),
      callPhone: phones.find(item => item.value)?.value || '',
      workingHours: Array.isArray(hours) ? hours.join('\n') : text(hours),
    },
    steps: list(settings.features?.steps),
    principles: settings.counts || {},
    instagram: settings.footer?.socialMedia?.instagram || 'https://instagram.com/zirve_dokum',
  };
}
